import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import {
  DecisionUploadFormLabel,
  DecisionUploadFormError,
} from '../components/DecisionUploadFormComponents';

type Props = {
  value: string;
  hasError: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const DecisionUploadNumberField: FC<Props> = ({
  value,
  hasError,
  onChange,
}) => {
  return (
    <>
      <DecisionUploadFormLabel htmlFor="upload-number">
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadNumberField.tsx/1" />
      </DecisionUploadFormLabel>
      <input
        id="upload-number"
        value={value}
        className={classNames(hasError && 'is-invalid-input')}
        name="number"
        placeholder="ex : XX/ZZZZZ"
        type="text"
        onChange={onChange}
      />
      {hasError && (
        <DecisionUploadFormError>
          <FormattedMessage id="upload/decision-upload/components/DecisionUploadNumberField.tsx/2" />
        </DecisionUploadFormError>
      )}
    </>
  );
};
